import { defaultTo } from 'ramda';
import { ITariffIdentificator as ITariffIdentificatorResponse } from '../../../../repositories/billing-tariffs/entities/Models/TariffIdentificator';
import { ITariffIdentificator } from '../../../../reducers/v2/publicationPackages/types';

export function mapTariffId(tariffIdentificator: ITariffIdentificatorResponse): ITariffIdentificator {
  return {
    ...tariffIdentificator,
    days: defaultTo(1, tariffIdentificator.days),
    serviceTypes: tariffIdentificator.serviceTypes!,
  };
}
